import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery, tsdaBaseQuery } from './baseQuery';
import { archLevel } from 'src/data/config';

export const feasibilityFormAPI = createApi({
  baseQuery: archLevel == 'sponsor' ? baseQuery : tsdaBaseQuery,
  reducerPath: 'FeasibilityFormAPI',
  endpoints: builder => ({
    createFormData: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country, application_module_section }) => ({
        url: `${formatString(
          endPoints.FeasibilityQuestionaries.create
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${application_module_section}`,
        body: data,
        method: 'POST'
      })
    }),
    selecteFeasibilityFormData: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country, application_module_section }) => ({
        url: `${formatString(
          endPoints.FeasibilityQuestionaries.select
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=STARTUP`,
        body: data,
        method: 'POST'
      })
    }),
    updateFeasibilityFormData: builder.mutation<any, any>({
      query: ({ data, site_id, study_id, country, application_module_section }) => ({
        url: `${formatString(
          endPoints.FeasibilityQuestionaries.update
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${application_module_section}`,
        body: data,
        method: 'POST'
      })
    }),
    getFeasibilityData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application }) => ({
        url: `${formatString(
          endPoints.Feasibility.select,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createFeasibility: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data }) => ({
        url: `${formatString(
          endPoints.Feasibility.create,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateFeasibility: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data }) => ({
        url: `${formatString(
          endPoints.Feasibility.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateFeasibilityCheckbox: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data }) => ({
        url: `${formatString(
          endPoints.Feasibility.updateCheckbox,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getAllFeasibility: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data, from = -1, size = -1 }) => ({
        url: `${formatString(
          endPoints.Feasibility.getAll
        )}?study_id=${study_id}&site_id=${site_id}&country=${country}&application=${application}${
          from > -1 ? `&from=${from}` : ''
        }${size > -1 ? `&size=${size}` : ''}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getFormLibrary: builder.mutation<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        published_version,
        OID,
        application,
        application_section,
        application_module_section
      }) => ({
        url: `${formatString(
          endPoints.toolkitFormsAPI.getFormLibrary,
          {
            key: urlKeys.OID,
            value: OID
          },
          {
            key: urlKeys.published_version,
            value: published_version
          }
        )}?form_type=Operational Form&site_id=${site_id}&study_id=${study_id}&country=${country}&application=${application}&application_section=${application_section}&application_module_section=${application_module_section}`,
        method: 'GET'
      })
    })
  })
});

export const {
  useCreateFormDataMutation,
  useSelecteFeasibilityFormDataMutation,
  useUpdateFeasibilityFormDataMutation,
  useGetFeasibilityDataQuery,
  useCreateFeasibilityMutation,
  useUpdateFeasibilityMutation,
  useUpdateFeasibilityCheckboxMutation,
  useGetAllFeasibilityMutation,
  useGetFormLibraryMutation
} = feasibilityFormAPI;
